import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { IntranetoldService } from 'src/app/api/intranetold.service';

@Component({
  selector: 'app-add-materiales',
  templateUrl: './add-materiales.component.html',
  styleUrls: ['./add-materiales.component.sass']
})
export class AddMaterialesComponent implements OnInit {

  constructor(
    private _api:IntranetoldService,
    public activeModal: NgbActiveModal
  ) { }

  public configuration: Config;
  public columns: Columns[];
  listaArticulos:any;
  data:any;
  ActualItemCode:any;

  async ngOnInit(): Promise<void> {

    this.columns = [
      { key: 'ItemCode', title: 'N° Artículo' },
      { key: 'U_IND_SWW', title: 'Código Transworld' },
      { key: 'ItemName', title: 'Descripción' },
    ];

    this.configuration = {
      ...DefaultConfig,
      searchEnabled: true,
      detailsTemplate: true,
      paginationRangeEnabled: true,
      paginationEnabled: true,
      horizontalScroll: true,
      resizeColumn: false,
      orderEnabled: true,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: true,
    };

    var data:any = await this._api.getQueryAll();
    var query:string = "";

    await data.objeto.forEach(element => {
      if(element.NOMBRE == "OITMmateriales") {
      query = element.CONSULTA;
      }
    });

    this.data = await this._api.GetNotFileQuery(query);
    this.data = this.data.objeto;


    let i = 0;
    this.data.forEach(element => {
      if (element.ItemCode == this.ActualItemCode) {
        this.data.splice(i,1)
      }
      i = i + 1;
    });

    

  }

  cerrar(row?) {
    this.activeModal.close(row);
  }

}
